var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThunderIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  fill: "none",
  viewBox: "0 0 8 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.672.37-.667 3.65c0 .15.089.224.2.224h3.47c.244 0 .4.325.288.576l-3.78 6.975c-.156.35-.623.225-.623-.175l.667-4.3c0-.15-.111-.1-.245-.1H.335c-.245 0-.423-.4-.29-.65L4.05.194c.156-.325.623-.225.623.175",
  clipRule: "evenodd"
})));
export { SvgThunderIcon as ReactComponent };
export default __webpack_public_path__ + "cf9533c40f54f91ed149cb9d5e9ca246.svg";